/** Sunucu hata gövdesi: { code, message, details }. Mesaj zaten Türkçe gelir. */
export class ApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status: number,
    public readonly details: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class NetworkError extends Error {
  constructor() {
    super('Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin; taslağınız cihazda saklanıyor.');
    this.name = 'NetworkError';
  }
}

export function messageOf(err: unknown): string {
  if (err instanceof ApiError || err instanceof NetworkError) return err.message;
  if (err instanceof Error) return err.message;
  return 'Beklenmeyen bir hata oluştu.';
}
